import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';

@Component({
  selector: 'error-message',
  templateUrl: 'error-message.template.html'
})
export class ErrorMessageComponent extends BaseComponent implements OnInit {


  @Input()
  iconClass = 'far fa-times-circle fa-5x';
  @Input()
  tittleKey = 'General.error';
  @Input()
  messageKey: string;
  message: string;

  constructor(public waitService: WaitLoadingService,
    private route: ActivatedRoute,
    public translate: TranslateService) {
    super();
  }

  ngOnInit() {
    this.waitService.cancelWaiting();
    this.subscribe(this.route.queryParams,
      (params: Params) => {
        this.iconClass = this.decodeParam('iconClass', params, this.iconClass);
        this.tittleKey = this.decodeParam('tittleKey', params, this.tittleKey);
        // this.messageKey = this.decodeParam('messageKey', params, this.messageKey);
        let msgKey = this.decodeParam('messageKey', params) || this.messageKey;
        if (!msgKey) {
          // consultar parametro mensaje o valor por defecto
          this.message = this.decodeParam('message', params, this.translate.instant('General.errorMessage'));
        } else {
          this.messageKey = msgKey
        }
      });
  }

  private decodeParam(key: string, params: Params, defaultValue?: string): string {
    let decodedText: string;
    if (params[key]) {
      try {
        decodedText = atob(params[key]);
      } catch (error) {
        console.error('Error al decodificar parametro:' + key + ' , con valor:' + params[key], error);
      }
    } else {
      decodedText = defaultValue;
    }
    return decodedText;
  }

}
